import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const HyrosScript: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.hyrosId) return null

    return (
        <Script id="hyros" strategy="afterInteractive">
            {`var head = document.head;
              var script = document.createElement('script');
              script.type = 'text/javascript';
              script.src = "${landingPage.integrations.hyrosId}&tag=!clicked&ref_url=" + encodeURI(document.URL) ;
              head.appendChild(script);
              `}
        </Script>
    )
}
